export const INDUSTRIES = [
  { slug: "manufacturing", name: "Manufacturing", icon: "factory" },
  { slug: "healthcare", name: "Healthcare", icon: "heart-pulse" },
  { slug: "aerospace", name: "Aerospace & Defense", icon: "plane" },
  { slug: "it-technical", name: "IT & Technical", icon: "laptop" },
  { slug: "accounting-finance", name: "Accounting & Financial", icon: "calculator" },
  { slug: "legal", name: "Legal", icon: "scale" },
  { slug: "blue-collar", name: "Blue Collar Jobs", icon: "hard-hat" },
  { slug: "construction", name: "Construction & Engineering", icon: "wrench" },
];

export const SERVICES = [
  {
    slug: "recruitment",
    icon: "search-user",
    title: "Recruitment Services",
    body:
      "Find the right talent faster with our end-to-end recruitment solutions. We source, screen, interview, and deliver highly qualified professionals for permanent and direct-hire positions across Construction, Healthcare, Engineering, Manufacturing, IT, Finance, and other specialized industries.",
    cta: "Hire Top Talent",
  },
  {
    slug: "staffing",
    icon: "users",
    title: "Staffing Solutions",
    body:
      "Build a flexible workforce with contract, temporary, contract-to-hire, and permanent staffing solutions. Our scalable hiring strategies help businesses reduce hiring time, increase productivity, and quickly meet changing workforce demands.",
    cta: "Find Talent",
  },
  {
    slug: "rpo",
    icon: "rpo",
    title: "RPO Services",
    body:
      "Transform your hiring process with customized Recruitment Process Outsourcing (RPO) solutions. From sourcing and screening to onboarding and workforce planning, we act as an extension of your team to improve hiring quality, reduce recruitment costs, and accelerate business growth.",
    cta: "Explore RPO",
  },
];

export const TEAM = [
  {
    slug: "vishan-dharmawat",
    name: "Vishan Dharmawat",
    role: "Head of Operations & Recruitment",
    linkedin: "https://www.linkedin.com/in/vishan-d-361488212/",
    photo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_snv-jobs/artifacts/oa07txc2_Vishan%20Website.png",
  },
  {
    slug: "vikas-tailor",
    name: "Vikas Tailor",
    role: "Recruitment & Staffing Manager",
    linkedin: "https://www.linkedin.com/in/vikas-tailor-478b261b1/",
    photo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_snv-jobs/artifacts/p9a906mq_Vikas%20Website.png",
  },
  {
    slug: "lavish-vasita",
    name: "Lavish Vasita",
    role: "Sales & Business Development Manager",
    linkedin: "https://www.linkedin.com/in/lavish-vasita-007/",
    photo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_snv-jobs/artifacts/pt0xax9u_Lavish%20Website.png",
  },
  {
    slug: "saloni-kothari",
    name: "Saloni Kothari",
    role: "Head of Marketing",
    linkedin: "https://www.linkedin.com/in/saloni-kothari-0522aa222/",
    photo: null,
  },
  {
    slug: "kunal-dwivedi",
    name: "Kunal Dwivedi",
    role: "Training Specialist",
    linkedin: "https://www.linkedin.com/in/kunal-dwivedi-000a7a38b/",
    photo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_snv-jobs/artifacts/8ra5wd83_Kunal%20Website.png",
  },
];

export const STATS = [
  { value: "15+", label: "Years of Experience" },
  { value: "10+", label: "Industries Served" },
  { value: "20K+", label: "Qualified Candidates Presented" },
  { value: "3.7K+", label: "Placements" },
];

export const OFFICES = [
  {
    country: "India — Headquarters",
    address: "Udaipur, Rajasthan",
    city: "India",
  },
  {
    country: "United States",
    address: "Dallas, TX",
    city: "United States",
  },
];

export const CONTACT = {
  email: "Vishan@Snvelite.com",
  phone: "912-915-2311",
};
